import { appealApi } from 'feature/appeals/redux/appeals.api'
import { useIsAuth } from 'feature/auth/hooks'
import { useCreateCompanyOrderMutation } from 'feature/company/redux/company.api'
import { useSetNotice } from 'hooks/useSetNotice'
import { useNavigate } from 'react-router'
import { useActions, useAppSelector, useThunkDispatch } from 'store/hooks'
import { Severity } from 'widget/Notifications'

import { ordersApi, useSendOrderFormMutation } from '../redux/orders.api'
import { getOrderLink } from '../types/OrderLink'

import { useProductFormData } from './useProductFormData'
import { TEditAppealProduct } from 'feature/appeals/type'

export const useSendOrderForm = () => {
  const [sendOrderForm] = useSendOrderFormMutation()
  const [createCompanyOrder] = useCreateCompanyOrderMutation()
  const { setActiveStepOrder, setDefaultFormData } = useActions()
  const setNotice = useSetNotice()
  const navigate = useNavigate()
  const thunkDispatch = useThunkDispatch()
  const isAuth = useIsAuth()
  const clientType = useAppSelector(state => state.auth.authInfo.clientType)
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const bankDetailsId = useAppSelector(
    state => state.orderForm.forms[currentEditForm].bankDetailsId,
  )
  const userType = useAppSelector(
    state => state.orderForm.forms[currentEditForm].userType,
  )

  const getFormData = useProductFormData(currentEditForm)
  const isCompanyUser = isAuth && clientType === 'company'

  const handleSuccess = () => {
    window.ym?.(107075503, 'reachGoal', 'finish_approve_form')
    setDefaultFormData()
    thunkDispatch(ordersApi.util.resetApiState())
    thunkDispatch(appealApi.util.resetApiState())
    navigate('/appeals')
  }

  const handleError = (error: {
    status: number
    data?: { message?: string }
  }) => {
    if (error.status === 401 || error.status === 423) {
      return
    }
    thunkDispatch(ordersApi.util.resetApiState())
    setNotice(
      error.data?.message ?? 'Ошибка при отправке заявки',
      Severity.error,
    )
    setActiveStepOrder(0)
    navigate(
      getOrderLink(currentEditForm, isCompanyUser ? 'company' : userType),
    )
  }

  return () => {
    const data = getFormData()

    if (isCompanyUser) {
      const { timeSlots, products, ...rest } = data

      const timeSlotsValue = timeSlots?.[0].date !== '' ? timeSlots : []

      const companyData = {
        ...rest,
        bankDetailsId: bankDetailsId,
        timeSlots: timeSlotsValue,
        products: products as TEditAppealProduct[],
      }

      createCompanyOrder(companyData)
        .unwrap()
        .then(handleSuccess)
        .catch(handleError)
    } else {
      const { timeSlots, ...rest } = data as typeof data & { user: unknown }
      let timeSlotsValue = timeSlots?.[0].date === '' ? null : timeSlots

      const userData = {
        ...rest,
        timeSlots: timeSlotsValue,
      }

      sendOrderForm(userData).unwrap().then(handleSuccess).catch(handleError)
    }
  }
}
